
export enum PlatformStatus {
    Active = 0,
    Inactive = 1
}
